// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SocialLoginButton-module__root--u3XIs {
  height: 56px;
  gap: 4px;
  padding-inline: 20px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 700;
  line-height: 22.5px;
}
.SocialLoginButton-module__root--u3XIs.SocialLoginButton-module__kakao--RtjBr {
  --button-background: #fee500;
  --button-border-color: #fee500;
  --button-color: #000;
}
.SocialLoginButton-module__root--u3XIs.SocialLoginButton-module__apple--aemuK {
  --button-background: #fff;
  --button-border-color: #fff;
  --button-color: #000;
 
  font-weight: 600;
}
.SocialLoginButton-module__root--u3XIs.SocialLoginButton-module__apple--aemuK.SocialLoginButton-module__reverse--JyfGS {
  --button-background: #000;
  --button-border-color: #000;
  --button-color: #fff;
}
.SocialLoginButton-module__root--u3XIs.SocialLoginButton-module__apple--aemuK.SocialLoginButton-module__reverse--JyfGS .SocialLoginButton-module__icon--s_wCf {
  filter: invert(1);
}
.SocialLoginButton-module__root--u3XIs.SocialLoginButton-module__google--lqJsy {
  --button-background: #131314;
  --button-border-color: #8e918f;
  --button-color: #e3e3e3;

  padding-inline: 12px;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
}
.SocialLoginButton-module__root--u3XIs.SocialLoginButton-module__google--lqJsy.SocialLoginButton-module__reverse--JyfGS {
  --button-background: #fff;
  --button-border-color: #747775;
  --button-color: #1f1f1f;
}
.SocialLoginButton-module__icon--s_wCf {
  display: block;
  width: 18px;
  height: 20px;
  object-fit: contain;
}

.SocialLoginButton-module__root--u3XIs.SocialLoginButton-module__google--lqJsy .SocialLoginButton-module__icon--s_wCf {
  width: 18px;
  height: 18px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/LoginPage/components/SocialLoginButton/SocialLoginButton.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,QAAQ;EACR,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,oBAAoB;AACtB;AACA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,oBAAoB;;EAEpB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,uBAAuB;;EAEvB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":[".root {\n  height: 56px;\n  gap: 4px;\n  padding-inline: 20px;\n  border-radius: 8px;\n  font-size: 15px;\n  font-weight: 700;\n  line-height: 22.5px;\n}\n.root.kakao {\n  --button-background: #fee500;\n  --button-border-color: #fee500;\n  --button-color: #000;\n}\n.root.apple {\n  --button-background: #fff;\n  --button-border-color: #fff;\n  --button-color: #000;\n \n  font-weight: 600;\n}\n.root.apple.reverse {\n  --button-background: #000;\n  --button-border-color: #000;\n  --button-color: #fff;\n}\n.root.apple.reverse .icon {\n  filter: invert(1);\n}\n.root.google {\n  --button-background: #131314;\n  --button-border-color: #8e918f;\n  --button-color: #e3e3e3;\n\n  padding-inline: 12px;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 20px;\n}\n.root.google.reverse {\n  --button-background: #fff;\n  --button-border-color: #747775;\n  --button-color: #1f1f1f;\n}\n.icon {\n  display: block;\n  width: 18px;\n  height: 20px;\n  object-fit: contain;\n}\n\n.root.google .icon {\n  width: 18px;\n  height: 18px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `SocialLoginButton-module__root--u3XIs`,
	"kakao": `SocialLoginButton-module__kakao--RtjBr`,
	"apple": `SocialLoginButton-module__apple--aemuK`,
	"reverse": `SocialLoginButton-module__reverse--JyfGS`,
	"icon": `SocialLoginButton-module__icon--s_wCf`,
	"google": `SocialLoginButton-module__google--lqJsy`
};
export default ___CSS_LOADER_EXPORT___;
